import { FC } from 'react'
import { useCustomTheme } from '@/core/theme'
import { formatDate } from '@core/utils/time'
import { Divider } from '@/ui/components/Divider/Divider.styles'
import CaseNumberDisplay from '@/ui/components/caseNumberDisplay'
import Typography from '@/ui/components/typography'
import { Row, MetaItem } from './CaseMetaRow.styles'
import { CaseMetaRowProps } from './CaseMetaRow.types'

const CaseMetaRow: FC<CaseMetaRowProps> = ({
    createdAt,
    lastModifiedAt,
    caseNumber,
    variant = 'incident',
}) => {
    const theme = useCustomTheme()

    const textColor = theme.colors.greys[800]

    const renderLabelledValue = (label: string, value: string) => (
        <MetaItem>
            <Typography variant="xs-semibold" color={textColor}>
                {label}
            </Typography>
            <Typography variant="xs-regular" color={textColor}>
                {value}
            </Typography>
        </MetaItem>
    )

    const renderDivider = () => (
        <Divider vertical height="15px" data-testid="case-meta-divider" />
    )

    const showLastModified =
        variant === 'serviceRequest' && Boolean(lastModifiedAt)

    return (
        <Row data-testid="case-meta-row">
            {renderLabelledValue(
                'Created Date:',
                createdAt ? formatDate(createdAt) : '-'
            )}
            {showLastModified && renderDivider()}
            {showLastModified &&
                renderLabelledValue(
                    'Last Modified:',
                    lastModifiedAt ? formatDate(lastModifiedAt) : '-'
                )}
            {caseNumber && renderDivider()}
            {caseNumber && (
                <MetaItem>
                    <Typography variant="xs-semibold" color={textColor}>
                        Case Number:
                    </Typography>
                    <CaseNumberDisplay caseNumber={caseNumber} showFull />
                </MetaItem>
            )}
        </Row>
    )
}

export default CaseMetaRow
